import { createFileRoute } from '@tanstack/react-router';
import { LobbyPage } from '../../features/lobby/lobby-page';

export const Route = createFileRoute('/_authenticated/lobby')({
  component: LobbyPage,
});
